import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useParams } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { Card } from 'primereact/card';
import { TabView, TabPanel } from 'primereact/tabview';
import { formatDatetime } from '../../Helper/constent';
import { Tag } from 'primereact/tag';

const ViewPurchaseRetrun = () => {
    const [rows, setRows] = useState([]);
    const [inactiveRows, setInactiveRows] = useState([]);
    const [purchaseDetails, setPurchaseDetails] = useState(null);
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const toast = useRef(null);
    const { purchase_return_id } = useParams();
    const [loading, setLoading] = useState(true);

    const headers = apiHeadersJson;

    const fetchPurchaseData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/ReturnManagement/GetPurchaseReturnProducts`, {
                params: { purchase_return_id, type: 1 },
                headers,
            });
            const { success, data, rows, inactive_rows, message } = response.data;
            if (success) {
                setPurchaseDetails(data[0]);
                setRows(rows || []);
                setInactiveRows(inactive_rows || []);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 3000 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (purchase_return_id) {
            fetchPurchaseData();
        }
    }, [purchase_return_id]);

    const renderPurchaseDetails = () => {
        if (!purchaseDetails) return null;
        return (
            <div className="grid">
                <div className="col-12 lg:col-6">
                    <Card title="Purchase Information">
                        <div>
                            <p><strong>Purchase Retrun ID:</strong> {purchaseDetails.purchase_return_id}</p>
                            <p><strong>Supplier:</strong> {purchaseDetails.supplier_name}</p>
                            <p><strong>Date & Time:</strong> {formatDatetime(purchaseDetails.created_date)}</p>
                            <p><strong>Total Amount:</strong> {purchaseDetails?.grand_total_amount}</p>
                            <div className="d-flex justify-content-between align-items-center">
                                <p><strong>Bill By:</strong> {purchaseDetails?.bill_by}</p>
                                {purchaseDetails?.last_action_by && <p><strong>Last Action By:</strong> {purchaseDetails?.last_action_by}</p>}
                            </div>

                        </div>
                    </Card>
                </div>
                <div className="col-12 lg:col-6">
                    <Card title="Additional Info">
                        <div>
                            <p><strong>From Store:</strong>{purchaseDetails.store_name ?? 'N/A'}</p>
                            <p><strong>Status:</strong> {purchaseDetails.purchase_return_status === 2 ? 'Verified' : 'Pending'}</p>
                            <p><strong>Address :</strong> {purchaseDetails.store_address ?? "N/A"} <span className='pi pi-arrow-right mx-2 text-primary'></span> {purchaseDetails.supplier_address ?? 'N/A'}</p>
                            {purchaseDetails.user_name && <p><strong>Verified By:</strong> {purchaseDetails.user_name}</p>}
                        </div>
                    </Card>
                </div>
            </div>
        );
    };

    const actionBy = (data) => {
        let value = data.stock_status === 2 ? `Edited By ${data.user_name}` : data.stock_status === 3 ? `Deleted By ${data.user_name}` : ''
        let severity = data.stock_status == 2 ? 'info' : data.stock_status == 3 ? 'danger' : '';
        return (
            <>
                <Tag severity={severity} value={value} />
            </>
        )
    };

    const actionDateTime = (data) => {
        return (
            <>
                {formatDatetime(data.updated_date)}
            </>
        )
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="mt-4">
                {/* <h2>Purchase Details</h2> */}
                {loading ? (
                    <Skeleton width="100%" height="300px" />
                ) : (
                    renderPurchaseDetails()
                )}
            </div>

            <div className="mt-4">
                <TabView>
                    <TabPanel header="Active Products">
                        {loading ? (
                            <Skeleton width="100%" height="200px" />
                        ) : (
                            <DataTable
                                value={rows}
                                rows={10}
                                stripedRows
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                            >
                                <Column field="product_name" header="Product Name" />
                                <Column field="product_qty" header="Quantity" />
                                <Column field="stock_purchase_price" header="Purchase Price" />
                                <Column field="stock_sale_price" header="Sale Price" />
                                <Column field="total_amount" header="Total Amount" />
                            </DataTable>
                        )}
                    </TabPanel>
                    <TabPanel header="Old Products">
                        {loading ? (
                            <Skeleton width="100%" height="200px" />
                        ) : (
                            <DataTable
                                value={inactiveRows}
                                rows={10}
                                stripedRows
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                            >
                                <Column field="product_name" header="Product Name" />
                                <Column field="product_qty" header="Quantity" />
                                <Column field="stock_purchase_price" header="Purchase Price" />
                                <Column field="stock_sale_price" header="Sale Price" />
                                <Column field="total_amount" header="Total Amount" />
                                <Column body={actionDateTime} header="Date & time" />
                                <Column header="Action By" body={actionBy} />
                            </DataTable>
                        )}
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default ViewPurchaseRetrun;
